<template>
    <div id="app">
        <quick-preloader v-show="isLoading"/>
        <site-header></site-header>
        <router-view></router-view>
        <site-separator separator="road"></site-separator>
        <site-footer></site-footer>
    </div>
</template>
<script>
import SiteFooter from './components/site/SiteFooter'
import SiteSeparator from './components/site/SiteSeparator'
import SiteHeader from './components/site/SiteHeader'
import QuickPreloader from './components/preloader'

export default {
  components: {
    QuickPreloader,
    SiteHeader,
    SiteSeparator,
    SiteFooter
  },
  data () {
    return {
      loader: true
    }
  },
  computed: {
    isLoading () {
      return this.loader
    }
  },
  mounted () {
    this.loader = false
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue